import { gql } from '@apollo/client'

export const Query = gql`
  query DocumentTypes($companyId: ID!, $filters: DocumentTypeFilters, $order: DocumentTypeOrder, $after: String, $before: String, $first: Int, $last: Int) {
    documentTypes(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        dateDue
        dateIssued
        freeagentResource
        xeroResource
        incrementStart
        incremental
        nextNumber
        subject
        crewVisible
        size
        orientation
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
